import React from "react"
import ToolTip from "react-portal-tooltip"
import strings from "../../localization/strings"
import FontIcon from "material-ui/FontIcon"
import { green500 } from "material-ui/styles/colors"
import { ILockedObjData, IPayrollLockedData } from "../../models"
import moment from "moment"
interface IProps {
	keyStr: string
	lockedData: IPayrollLockedData | ILockedObjData
	employeeLock?: boolean
}
interface IState {
	open: boolean
}

export default class PayrollByHierarchyTableLockedColumn extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return (
			<div>
				<ToolTip active={this.state.open} position="bottom" arrow="center" parent={"#" + "lock-" + this.props.keyStr}>
					<div style={{ paddingLeft: 15, paddingRight: 15, textAlign: "center" }}>
						<span style={{ fontWeight: 600 }}>{this.props.employeeLock ? strings.Employee_Locked : strings.Locked}</span>
						<br />
						<span>{moment(this.props.lockedData.LockedDateTime).format("hh:mma MM/DD/YYYY")}</span>
						<br />
						<span>{`${this.props.lockedData.LockedUserName}`}</span>
					</div>
				</ToolTip>
				<div style={{ marginTop: -5, fontSize: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
					<FontIcon
						id={"lock-" + this.props.keyStr}
						className={this.props.employeeLock ? "fa fa-user-lock" : "fa fa-lock"}
						style={{ fontSize: 18, color: green500 }}
						onMouseOver={() => this.setState({ open: true })}
						onMouseOut={() => this.setState({ open: false })}
					/>
				</div>
			</div>
		)
	}
}